// ==============================|| COI CHECK TYPES ||============================== //

import { MinDto, NamedEntityMinDto } from './other';

export interface CoiCheckSummary extends CoiCheck {
    countsByScopeType: CoiCheckScopeTypeCount[];
    /** A spelling of the search term that finds something; only set when this check found nothing. */
    didYouMean?: string | null;
}

export interface CoiCheckListItem extends CoiCheck {
    relations: CoiCheckRelation[];
}

interface CoiCheck {
    id: number;
    searchTerm: string;
    checkedByEmployee: { id: number; name: string };
    checkedAt: Date;
}

export interface CoiCheckDto {
    searchTerm: string;
}

export interface CoiCheckRelation {
    id: number;
    coiCheckScopeTypeCode: string;
    entityName: string;
    entityId: number;
    isManuallySelected?: boolean;
    detailsJson: CoiCheckDetailsJson;
}

export interface CoiCheckDetailsJson {
    id: number;
    isConfidential?: boolean;
    visibility?: VisibilityScope;
    name?: string;
    previousNames?: string;
    officialFirstName?: string;
    officialLastName?: string;
    localFirstName?: string;
    localLastName?: string;
    notes?: string;
    vatRegNum?: string;
    regCode?: string;
    officialName?: string;
    officialLocalName?: string;
    partyGroups?: NamedEntityMinDto[];
    email?: string;
    description?: string;
    state?: string;
    date?: Date;
    employees?: EmpDto[];
    employee?: NamedEntityMinDto;
    pathname?: string;
    parties?: PartyDto[];
    matters?: MatterDto[];
    searchTerm?: string;
    personalIdCode?: string;
    number?: string;
    matterClient?: MinDto;
    lastTimecardDate?: Date;
    partyPersons?: NamedEntityMinDto[];
    partyCompanies?: NamedEntityMinDto[];
    uboCompanies?: NamedEntityMinDto[];
    partyEmployees?: NamedEntityMinDto[];
}

export interface MatterDto extends NamedEntityMinDto {
    number: string;
}

export interface PartyDto extends NamedEntityMinDto {
    matterPartyRoleTypeCode?: string;
    role?: 'CLIENT' | 'PAYER';
}

export interface EmpDto extends NamedEntityMinDto {
    partyEmployeeTypeCode?: string;
}

export type CoiCheckScopeTypeCount = {
    scopeType: string;
    totalCount: number;
};

export enum CoiCheckScopeType {
    CLIENT = 'CLIENT',
    COMPANY = 'COMPANY',
    EFFORT = 'EFFORT',
    EMPLOYEE = 'EMPLOYEE',
    EXPENSE = 'EXPENSE',
    INVOICE = 'INVOICE',
    MATTER = 'MATTER',
    OPPONENT = 'OPPONENT',
    PERSON = 'PERSON',
    PREVIOUS_COI = 'PREVIOUS_COI',
    TIMECARD = 'TIMECARD',
}

export enum VisibilityScope {
    FULL = 'FULL',
}

export interface CoiCheckEmailForm {
    additionalContent: string;
    employees: NamedEntityMinDto[];
    replyTo: string[];
}

export interface CoiCheckEmailData {
    id: number;
    searchTerm: string;
    checkedAt: Date;
}

export interface CoiCheckRelationDto {
    coiCheckScopeTypeCode: CoiCheckScopeType;
    entityName: string;
    entityId: number;
}

export interface CoiCheckAddRelationForm {
    clients: NamedEntityMinDto[];
    cases: NamedEntityMinDto[];
}
